import { FC, useEffect } from "react";
export const RedirectPage: FC = () => {
  useEffect(() => {
    window.location.href = '/member/schedule-board';
  }, []);

  return <div></div>
}